
import React from "react";
import { i18nManager } from "../../../../../i18n";
import { IPlatform, IProfile } from "../../../../../services";
import { Route, Routes, useSearchParams } from "react-router-dom";
import Requests from "./Requests";
import TicketRequest from "./TicketRequest";

export interface TicketsProps {
    profile: IProfile;
    platform?: IPlatform;
}

function Tickets(props: TicketsProps) {
    const [searchParams, _] = useSearchParams(window.location.search);
    const labels = i18nManager.Labels.dashboard.platform_management.management.support;

    return (<Routes>
        <Route path="/requests" element={<Requests profile={props.profile} platform={props.platform!} />} />
        <Route path="/requests/:ticketId" element={<TicketRequest profile={props.profile} platform={props.platform!} />} />
    </Routes>);

}

export default Tickets;
